import { Injectable } from '@angular/core';
import { TranslateService, MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { Logger } from './logger.service';
import { TranslationHelperService } from './translation-helper.service';

@Injectable({
	providedIn: 'root'
})
export class CassMissingTranslationHandlerService implements MissingTranslationHandler {

	constructor(private logger: Logger, private _translationHelper: TranslationHelperService) { }

	// The same missing key is usually reported a few times during rendering of a page/component.
	// We are planning to send browser logs to the backend, so the reportedKeysCache is used to report any missing key only once.
	private reportedKeysCache: any = {};

	handle(params: MissingTranslationHandlerParams) {
		if (params && params.key) {
			const mode = this._translationHelper.getTestMode();
			if (mode !== "normal" || !this.reportedKeysCache[params.key] && params.translateService.currentLang) {
				this.reportedKeysCache[params.key] = true;
				this.logger.error("Translate", `The key="${params.key}" is missing in the i18n files for lang ${params.translateService.currentLang}`);
			}
			if (mode === "normal") {
				// Try English (ngx translate module is initialised with 'en')
				const res = params.translateService.parser.interpolate(params.translateService.parser.getValue(params.translateService.translations['en'], params.key), params.interpolateParams)
				if (res) return res;
				// Return only the last segment of the key as it's often pretty close to the desired string
				return params.key.split(".").at(-1)?.replaceAll("_", " ");
			}
			else {
				switch (mode) {
					case 'test_all_keys':
					case 'test_missing_key':
						return params.key;
					case 'test_missing_cross':
						return '\u26DD';
					case 'test_ticks_and_missing_keys':
						// If found in translation, show tick, otherwise show key
						const res = params.translateService.parser.interpolate(params.translateService.parser.getValue(params.translateService.translations[this._translationHelper.lastLang ?? 'en'], params.key), params.interpolateParams)
						if (res) return '\u2714';
						return params.key;
				}
			}
		}
		return;
	}
}
